import NoFilter from '../../../../DataTable/datatable.nofilter';
import { Quality, QualityValue, QualityValueSample } from '../../../../Types/LotDetailQuality';

export interface SampleUsagesColumnProps {
    header: string,
    qualityType: string,
}
export function SampleUsagesColumn({ header, qualityType }: SampleUsagesColumnProps) {
    return {
        Header: header,
        id: header,
        accessor: 'usages',
        Filter: NoFilter,
        Cell: ({ row }: any) => {

            let usage = "";

            let quality: Quality = row.original;

            quality.qualityValues.forEach(function (qualityValue: QualityValue) {
                if (qualityValue.testMethod === qualityType) {
                    let samples: QualityValueSample[] = qualityValue.qualityValueSamples;

                    let distinctSampleUsages = [...new Set(samples.map(s => s.usage))]; // The distinct list of the first character of any usages for lab results used for this value
                    usage = distinctSampleUsages.join(",");
                }
            });

            return usage;
        }
    };
}